import { render, staticRenderFns } from "./AppNavi.vue?vue&type=template&id=3fba97e7&scoped=true&"
import script from "./AppNavi.vue?vue&type=script&lang=js&"
export * from "./AppNavi.vue?vue&type=script&lang=js&"
import style0 from "./AppNavi.vue?vue&type=style&index=0&id=3fba97e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba97e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fba97e7')) {
      api.createRecord('3fba97e7', component.options)
    } else {
      api.reload('3fba97e7', component.options)
    }
    module.hot.accept("./AppNavi.vue?vue&type=template&id=3fba97e7&scoped=true&", function () {
      api.rerender('3fba97e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavi.vue"
export default component.exports